export const ROW_HEIGHT = 72;
export const PINNED_COLUMN_FIELDS = ['photo', 'product'] as const;
